import React from "react";
import { ThirdPartyFee } from "../utils/thirdPartyFees";
import { formatCurrency } from "../utils/numberFormatting";

interface ThirdPartyFeesProps {
  fees: ThirdPartyFee[];
}

const ThirdPartyFees: React.FC<ThirdPartyFeesProps> = ({ fees }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Third Party Fees
      </h3>

      {/* Mobile View */}
      <div className="md:hidden space-y-3">
        {fees.map((fee, index) => (
          <div key={index} className="flex items-center gap-2">
            <span className="text-sm font-medium text-gray-500 w-24">
              {fee.name === "Title Estimate" ? "Title² (estimate)" : fee.name}:
            </span>
            <span className="text-gray-700">${formatCurrency(fee.value)}</span>
          </div>
        ))}
      </div>

      {/* Desktop View */}
      <div className="hidden md:block">
        <table className="w-auto">
          <tbody>
            {fees.map((fee, index) => (
              <tr
                key={index}
                className="border-b border-gray-200 last:border-b-0"
              >
                <td className="py-3 px-4 text-sm font-medium text-gray-500">
                  {fee.name === "Title Estimate"
                    ? "Title² (estimate)"
                    : fee.name}
                </td>
                <td className="py-3 px-4 text-gray-700 text-right">
                  ${formatCurrency(fee.value)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ThirdPartyFees;
